import React, { useState, useRef } from 'react';
import { Navbar as NavbarBootstrap, Collapse, Container, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { CSSTransition, SwitchTransition  } from 'react-transition-group';

// COMPONENTES
import SearchBar from './SearchBar/SearchBar';
import ShareModal from 'modules/glifos-rich-media/components/CreateSegment/ShareModal/ShareModal';
import EmailModal from 'modules/glifos-rich-media/components/CreateSegment/EmailModal/EmailModal';

// IMAGENES
import logo from 'assets/img/JPE_banner.jpg';
import logo_s_nav from 'assets/img/JPE_small_nav.png'
import logo_w from 'assets/img/JPE_white_banner.png'

// ESTILOS
import styles from './Navbar.module.scss';
import './ExtraStyle/dropStyle.scss';

// ICONOS
import { MdEmail } from "react-icons/md";
import { IoShareSocialSharp } from "react-icons/io5";
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { RiExpandDiagonalLine } from "react-icons/ri";
import EmailSender from 'modules/glifos-rich-media/components/EmailSender/EmailSender';

function FullNavbar({ navigate, useWhiteLogo }) {
	return (
	  <div className='d-flex flex-column w-100' style={{ backgroundColor: '#1E1E1E' }}>
		<div className={`d-flex ${useWhiteLogo ? styles.img_back_white : styles.img_back}`} onClick={() => navigate('/')}>
		  <Link to='/' width="50%">
			<img src={useWhiteLogo ? logo_w : logo} width="100%" alt='JPEE logo' />
		  </Link>
		</div>
		<div className={`w-100 d-flex ${styles.nav_back}`}>
		<Container>
			<div className="d-flex justify-content-lg-end justify-content-md-center mx-4">
			  <SearchBar />
			</div>
		</Container>
		</div>
	  </div>
	);
}

function SmallNavbar({ navigate, isCollapsed, handleToggleCollapse, titlePage }) {
	const [showModalShare, setShowModalShare] = useState(false);
	const [showModalEmail, setShowModalEmail] = useState(false);

	return (
		<>
			<Collapse in={!isCollapsed}>
				<div className={styles.navSmall}>
					<Container className='px-5'>

						{/* MOBILE LAYOUT (xs-md) */}
						<div className="d-flex d-lg-none flex-column align-items-center text-center">
							<button
								className={`${styles.toggleButton} mb-2`}
								onClick={handleToggleCollapse}
							>
								<RiCollapseDiagonalLine />
							</button>

							<img
								src={logo_s_nav}
								alt="JPEE small logo"
								className={`${styles.smallLogo} mb-2`}
								onClick={() => navigate('/')}
							/>

							<div className="d-flex gap-3 mb-2">
								{/* <button
									onClick={() => setShowModalEmail(true)}
									className={`btn ${styles.iconButton}`}
								>
									<MdEmail className={styles.icon} />
									<span className={styles.icons_label}>E-mail</span>
								</button>
								<EmailModal
									show={showModalEmail}
									handleClose={() => setShowModalEmail(false)}
									titleName={titlePage}
								/> */}
								<EmailSender />
								<button
									onClick={() => setShowModalShare(true)}
									className={`btn ${styles.iconButton}`}
								>
									<IoShareSocialSharp className={styles.icon} />
									<span className={styles.icons_label}>Share</span>
								</button>
								<ShareModal
									show={showModalShare}
									handleClose={() => setShowModalShare(false)}
								/>
							</div>

							<div className="d-flex justify-content-center w-100">
								<SearchBar />
							</div>
						</div>

						{/* DESKTOP LAYOUT (lg+) */}
						<Row className="d-none d-lg-flex align-items-center">
							<div className={`${styles.stickyToggleButton}`}>
								<button className={styles.toggleButton} onClick={handleToggleCollapse}>
									<RiCollapseDiagonalLine />
								</button>
							</div>
							<Col xs="auto" className="d-flex align-items-center gap-3">
								<img
									src={logo_s_nav}
									alt="JPEE small logo"
									className={styles.smallLogo}
									onClick={() => navigate('/')}
								/>
							</Col>

							<Col className="d-none d-lg-block"></Col>

							<Col xs="auto" className="d-flex align-items-center me-4">
								<div className="d-flex align-items-center">
									{/* <button
										onClick={() => setShowModalEmail(true)}
										className={`btn ${styles.iconButton}`}
									>
										<MdEmail className={styles.icon} />
										<span className={styles.icons_label}>E-mail</span>
									</button>
									<EmailModal
										show={showModalEmail}
										handleClose={() => setShowModalEmail(false)}
										titleName={titlePage}
									/> */}
									<EmailSender />

									<button
										onClick={() => setShowModalShare(true)}
										className={`btn ${styles.iconButton}`}
									>
										<IoShareSocialSharp className={styles.icon} />
										<span className={styles.icons_label}>Share</span>
									</button>
									<ShareModal
										show={showModalShare}
										handleClose={() => setShowModalShare(false)}
									/>
								</div>

								<div className="d-flex align-items-center justify-content-start">
									<SearchBar />
								</div>
							</Col>
						</Row>
					</Container>
				</div>
			</Collapse>

			{isCollapsed && (
				<div className="d-flex justify-content-center">
					<button className={styles.stickyToggleButton} onClick={handleToggleCollapse}>
						<RiExpandDiagonalLine />
					</button>
				</div>
			)}
		</>
	);
}
 
export default function Navbar({ isScrolled, useWhiteLogo, titlePage }) {
	const navigate = useNavigate()
	const [isCollapsed, setIsCollapsed] = useState(false);
	const nodeRef = useRef(null);

	const handleToggleCollapse = () => {
		setIsCollapsed(!isCollapsed);
	}

	return (
		<>
		  <div className={styles.full_navbar}>
			<FullNavbar navigate={navigate} useWhiteLogo={useWhiteLogo} />
		  </div>
		  <CSSTransition
				in={isScrolled}
				timeout={600}
				classNames={{
					enter: styles.slideDownEnter,
					enterActive: styles.slideDownEnterActive,
					exit: styles.slideDownExit,
					exitActive: styles.slideDownExitActive,
				}}
				unmountOnExit
				nodeRef={nodeRef}
				appear
			>
				<div ref={nodeRef} className={styles.small_navbar}>
				<SmallNavbar
					navigate={navigate}
					isCollapsed={isCollapsed}
					handleToggleCollapse={handleToggleCollapse}
					titlePage={titlePage}
				/>
				</div>
			</CSSTransition>
		</>
	  );
}
